<template>
  <div>
    <!-- Card 1 - Dados Básicos -->
    <b-card header="Informações do Registro" class="mb-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="Data de Cadastro:" label-for="input-data-cadastro">
            <b-form-datepicker id="input-data-cadastro" v-model="empresa.data_cadastro" class="mb-2"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-br">
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="Data de Atualização:" label-for="input-data-atualizacao">
            <b-form-datepicker id="input-data-atualizacao" v-model="empresa.data_atualizacao" class="mb-2"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-br">
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>
      </div>
    </b-card>
    <b-card header="Dados Básicos" class="mb-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="Razão Social:" label-for="input-razao">
            <b-form-input id="input-razao" v-model="empresa.nome" placeholder="Razão Social" required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="CNPJ:" label-for="input-cnpj">
            <b-form-input id="input-cnpj" v-model="empresa.cnpj" v-mask="['##.###.###/####-##']"
              placeholder="CNPJ da Empresa" required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="Telefone:" label-for="input-telefone">
            <b-form-input id="input-telefone" v-model="empresa.telefone" placeholder="Telefone da Empresa"
              required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="E-mail:" label-for="input-email">
            <b-form-input id="input-email" v-model="empresa.email" type="email" placeholder="E-mail da Empresa"
              required></b-form-input>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <!-- Card 2 - Dados de Endereço -->
    <b-card header="Endereço da Empresa" class="mb-3">
      <div class="row">
        <div class="col-6 col-md-2 mb-3">
          <b-form-group label="CEP:" label-for="input-cep">
            <b-form-input id="input-cep" v-model="empresa.cep" v-mask="['#####-###']" placeholder="CEP da Empresa"
              required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6 col-md-10 mb-3">
          <b-form-group label="Endereço:" label-for="input-endereco">
            <b-form-input id="input-endereco" v-model="empresa.endereco" placeholder="Endereço" required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6 col-md-2 mb-3">
          <b-form-group label="Estado">
            <select v-model="estadoSelecionado" class="form-control">
              <option value="" selected>{{ estadoEmpresa }}</option>
              <option v-for="estado of estados" :key="estado.id_estado"
                :value="{ uf: estado.sigla, id: estado.id_estado }">
                {{ estado.nome }}
              </option>
            </select>
          </b-form-group>
        </div>

        <div class="col-6 col-md-10 mb-3">
          <b-form-group label="Cidade">
            <select v-model="cidadeSelecionada" class="form-control">
              <option>Selecione a Cidade</option>
              <option value="" selected>{{ cidadeEmpresa }}</option>
              <option v-for="cidade of cidades" :key="cidade.ibge" :value="{
                idMunicipio: cidade.id_municipio,
                idEstado: cidade.id_estado,
                ibge: cidade.ibge,
                nome: cidade.nome
              }">
                {{ cidade.nome }}
              </option>
            </select>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <!-- Card 3 - Dados de Acesso -->
    <b-card header="Dados de Acesso" class="mb-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="Login:" label-for="input-login">
            <b-form-input id="input-login" v-model="empresa.login" placeholder="Login da Empresa"
              required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-group label="Senha:" label-for="input-senha">
            <b-form-input id="input-senha" v-model="empresa.senha" type="password" placeholder="Senha"
              required></b-form-input>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <!-- Card 4 - Configurações -->
    <b-card header="Configurações" class="mb-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <b-form-checkbox v-model="empresa.is_digital_signature">
            Habilitar Assinatura Digital
          </b-form-checkbox>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-checkbox v-model="empresa.is_api">
            Habilitar API
          </b-form-checkbox>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-checkbox v-model="empresa.nf">
            Emitir Nota Fiscal
          </b-form-checkbox>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <b-form-checkbox v-model="empresa.is_test">
            Empresa para teste?
          </b-form-checkbox>
        </div>

        <div class="col-12 col-md-12 mb-3">
          <b-form-group label="Tipo de Contrato:" label-for="select-tipo-contrato">
            <b-form-select id="select-tipo-contrato" v-model="empresa.tipo_contrato" :options="[
              { value: 'mensal', text: 'Mensal' },
              { value: 'anual', text: 'Anual' },
              { value: 'creditos', text: 'Créditos' }
            ]" required></b-form-select>
          </b-form-group>
        </div>

        <div class="col-12 col-md-12 mb-3">
          <b-form-group label="Nome do Responsável" label-for="input-responsavel">
            <b-form-input id="input-responsavel" v-model="empresa.responsavel" placeholder="Nome do Responsável"
              required></b-form-input>
          </b-form-group>
        </div>
      </div>
    </b-card>
    <b-button type="submit" variant="success" @click.prevent="salvarEmpresa">Salvar</b-button>
    <loading :active.sync="isLoading" color="#008e75" :can-cancel="true"></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import estadoService from '@src/services/estado'
import empresaService from '@src/services/empresa_sistema'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  components: { Loading },
  props: {
    empresa: {},
  },

  data() {
    return {
      estadoEmpresa: '',
      cidadeEmpresa: '',
      estadoSelecionado: '',
      cidadeSelecionada: '',
      cidades: [],
      estados: [],
      isLoading: true,
      modal: {
        mensagems: [],
        show: false,
      },
    }
  },

  watch: {
    estadoSelecionado(newValue) {
      this.listandoCidade(newValue.id)
      this.empresa.id_estado = newValue.id
    },
    cidadeSelecionada(newValue) {
      this.empresa.id_municipio = newValue.idMunicipio
    },
  },

  mounted() {
    this.listaEstado()
    this.selecionaMunicipio()
  },

  methods: {
    lista() {
      for (const estado of this.estados) {
        if (estado.id_estado == this.empresa.id_estado) {
          this.estadoEmpresa = estado.nome
        }
      }

      for (const cidade of this.cidades) {
        if (cidade.id_municipio == this.empresa.id_municipio) {
          this.cidadeEmpresa = cidade.nome
        }
      }
    },

    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },

    listaEstado() {
      const token = this.$store.state.auth.currentUser.token

      estadoService.lista(token).then((resposta) => {
        this.estados = resposta.data.estados
        this.isLoading = this.loading(this.isLoading)
        this.listandoCidade(this.empresa.id_estado)
      })
    },

    listandoCidade(id) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)

      estadoService.listaCidades(token, id).then((resposta) => {
        this.cidades = resposta.data.cidades
        this.isLoading = this.loading(this.isLoading)
        this.lista()
      })
    },

    selecionaMunicipio() {
      if (this.empresa.id_municipio) {
        const token = this.$store.state.auth.currentUser.token
        estadoService
          .municipio(token, this.empresa.id_municipio)
          .then((resposta) => {
            this.empresa.ibge = Number(resposta.data.ibge)
            this.listaCidade(this.empresa.id_estado)
          })
      }
    },

    limparFormularioEmpresa() {
      this.empresa = {
        nome: '',
        cnpj: '',
        telefone: '',
        email: '',
        registro_siga: '',
        login: '',
        senha: '',
        cep: '',
        endereco: '',
        estadoSelecionado: '',
        cidadeSelecionada: '',
      }
    },

    salvarEmpresa() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      const tratarResposta = (resposta) => {
        this.isLoading = false
        if (resposta.data.sucesso) {
          this.$bvToast.toast(resposta.data.mensagem, {
            variant: 'success',
            solid: true,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.limparFormularioEmpresa()
          this.$root.$emit('back')
        } else if (
          resposta.data.statusCode &&
          resposta.data.statusCode !== 200
        ) {
          this.$bvToast.toast(resposta.data.message, {
            variant: 'danger',
            solid: true,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        }
      }

      const tratarErro = (erro) => {
        this.isLoading = false
        let mensagemErro =
          erro.response && erro.response.data && erro.response.data.message
            ? erro.response.data.message
            : 'Erro desconhecido'
        this.$bvToast.toast(mensagemErro, {
          variant: 'danger',
          solid: true,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      }
      delete this.empresa.logo
      const acao = this.empresa.id_empresa_sistema
        ? empresaService.atualizarEmpresa(token, this.empresa)
        : empresaService.salvarEmpresa(token, this.empresa)

      acao.then(tratarResposta).catch(tratarErro)
    },
  },
}
</script>

<style></style>
